<template>
    <div>
        <div class="langtoggle">
            <LanguageSwitch></LanguageSwitch>
        </div>
        <div v-if="!shopSwitch" class="c-app" style="background-color: #ffffff">
            <div class="c-wrapper">
                <div class="c-body">
                    <div class="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center" style="height: 100vh;">
            <div class="text-center p-4 info-box">
                <img src="/img/redirect.webp" width="30%" class="mb-4 pl-4">
                <h4 v-html="$t('swapShop')"></h4>
                <span class="text-description">
                    {{ $t('swapShopDespt') }}</span>
                <CButton @click="redirectToNewShop()" class="btn-color-theme bg-color-theme mt-4 " block
                    color=" success">{{ $t('confirm') }}
                </CButton>
                <h5 @click="backToLastShop()" class="mt-5 text-dark" style="text-decoration: underline;">
                    {{ $t('cancel')
                    }}</h5>
            </div>
            <div class="fixed-bottom d-flex justify-content-center">
                <div class="text-center pb-2">
                    Powered by <br>
                    <img src="/logo.png" width="25%">
                </div>
            </div>
        </div>
        <div v-if="isLineIOS" class="ios-guide-overlay">
            <div class="ios-guide-box">
                <img src="/img/directlink2.png" width="100%" class="mt-1" />
            </div>
        </div>
        <!-- <div v-if="showIOSGuide" class="ios-guide-overlay">
            <div class="ios-guide-box text-center p-4">
                <img src="/img/directlink2.png" width="100%" class="mt-1" />
                <CButton class="mt-3" block   @click="ackIOSGuide">
                เข้าใจแล้ว
                </CButton>
            </div>
        </div> -->
        <div v-if="iosGuideVisible" class="ios-guide-overlay">
            <div class="ios-guide-box">
                <!-- <h4>เปิดใน Safari</h4>

                <p class="mt-2">
                เพื่อความปลอดภัยและการใช้งานที่สมบูรณ์<br>
                กรุณาเปิดหน้านี้ใน <b>Safari</b>
                </p>

                <ol class="text-left mt-3">
                <li>แตะ <b>⋯ มุมล่างขวา</b></li>
                <li>เลือก <b>“เปิดใน Safari/Browser/Chrome”</b></li>
                </ol> -->

                <img src="/img/directlink2.png" width="100%" class="mt-1" />

                <CButton block class="mt-4" @click="ackIOSGuide">
                เข้าใจแล้ว
                </CButton>
            </div>
        </div>

    </div>
</template>

<script>
import poscrm from '@/services/poscrm'
import LanguageSwitch from '@/components/AppLanguageSwitch'
import util from '@/util/util'

export default {
  components: { LanguageSwitch },

  data() {
    return {
      shopName: '',
      shopData: {},
      shopSwitch: false,
      iosGuideVisible: false,
      openedFromLineIOS: false,
      isLineIOS: false
    }
  },

created() {
  const ua = navigator.userAgent
  const isIOS = util.isIOS()
  const ctx = util.detectContext()
  const isAndroid = util.detectContext()
  const isLine = /Line/i.test(ua)
  const isFacebook = /FBAN|FBAV/i.test(ua)

  if ((isIOS || ctx.isAndroid) && isLine) {
    this.isLineIOS = true
    this.iosGuideVisible = true
  }

  if (isIOS && isFacebook) {
    const seen = sessionStorage.getItem('ios_fb_guide_seen')
    if (!seen) {
      this.iosGuideVisible = true
      sessionStorage.setItem('ios_fb_guide_seen', '1')
      return
    }
  }

  this.checkPathUniqueName()
},

  methods: {
    // ===== iOS Guide =====
    ackIOSGuide() {
      this.iosGuideVisible = false
      this.checkPathUniqueName()
    },

    // ===== Business =====
    async checkPathUniqueName() {
      this.shopName = this.$route.params.param || ''
      if (!this.shopName) return

      try {
        const res = await poscrm({
          method: 'get',
          url: '/api/v3.0/shop/check/path/uniquename',
          headers: { uniqueName: this.shopName }
        })

        this.shopData = res?.data?.data || {}

        if (this.shopData?.isUsed) {
          this.checkRedirectShop()
        } else {
          localStorage.clear()
          sessionStorage.clear()
          window.location.href = '/404'
        }
      } catch (err) {
        console.error('API error:', err)
      }
    },

    checkRedirectShop() {
        // 🚫 LINE iOS: ห้าม redirect ใด ๆ
        if (this.isLineIOS) {
            return
        }
        
      const oldId = localStorage.getItem('shopObjectId')
      const newId = this.shopData.shopObjectId

      if (!oldId) {
        this.redirectToNewShop()
      } else if (oldId !== newId) {
        this.shopSwitch = true
      } else {
        this.redirectToNewShop()
      }
    },

    redirectToNewShop() {
      localStorage.removeItem('uid')
      localStorage.removeItem('shopObjectId')

      window.location.href =
        `/delivery/home?uid=${this.shopData.uid}&shopObjectId=${this.shopData.shopObjectId}`
    },

    backToLastShop() {
      const uid = localStorage.getItem('uid')
      const shopObjectId = localStorage.getItem('shopObjectId')

      window.location.href =
        `/delivery/home?uid=${uid}&shopObjectId=${shopObjectId}`
    }
  }
}
</script>

<style scoped>
.langtoggle {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1050;
  padding: 20px;
}

.ios-guide-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ios-guide-box {
  background: #fff;
  border-radius: 20px;
  padding: 6px;
  max-width: 360px;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont;
}
</style>
